export const fallbackPriceCards = [
  { id: 'gc25', value: 25, label: '$25' },
  { id: 'gc50', value: 50, label: '$50' },
  { id: 'gc100', value: 100, label: '$100' },
  { id: 'gc150', value: 150, label: '$150' },
  { id: 'gc250', value: 250, label: '$250' },
  { id: 'gc300', value: 300, label: '$300' },
];
